import { useMutation } from '@tanstack/react-query';
import { timeOffService } from '../api/time-off.service';
import type { CreateMemberAdjustmentPayload } from '../types';

/** Applies a manual balance adjustment to a member's currently open cycle. Owner/Admin only. */
export function useCreateMemberAdjustment() {
  return useMutation({
    mutationFn: ({ userId, payload }: { userId: string; payload: CreateMemberAdjustmentPayload }) =>
      timeOffService.createMemberAdjustment(userId, payload),
  });
}
